import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  serverTimestamp,
  updateDoc
} from 'firebase/firestore';
import { auth, db } from '../firebase/config';

const GUEST_GROUPS_COLLECTION = 'conviventieGuestGroups';

const getUserEmail = () => auth.currentUser?.email || 'unknown';

const sortGuestGroups = (a, b) => (a.name || '').localeCompare(b.name || '');

export const getGuestGroups = async () => {
  try {
    const snapshot = await getDocs(collection(db, GUEST_GROUPS_COLLECTION));

    const groups = [];
    snapshot.forEach((docSnapshot) => {
      groups.push({
        id: docSnapshot.id,
        ...docSnapshot.data()
      });
    });

    groups.sort(sortGuestGroups);
    return groups;
  } catch (error) {
    console.error('Error getting conviventie guest groups:', error);
    throw error;
  }
};

export const addGuestGroup = async (payload) => {
  try {
    const userEmail = getUserEmail();

    const docPayload = {
      ...payload,
      name: (payload?.name || '').trim(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      createdBy: userEmail,
      updatedBy: userEmail
    };

    const docRef = await addDoc(collection(db, GUEST_GROUPS_COLLECTION), docPayload);

    return {
      id: docRef.id,
      ...docPayload,
      createdAt: new Date(),
      updatedAt: new Date()
    };
  } catch (error) {
    console.error('Error adding conviventie guest group:', error);
    throw error;
  }
};

export const updateGuestGroup = async (groupId, updates) => {
  try {
    const userEmail = getUserEmail();
    const payload = {
      ...updates,
      name: updates?.name !== undefined ? (updates.name || '').trim() : undefined,
      updatedAt: serverTimestamp(),
      updatedBy: userEmail
    };

    await updateDoc(doc(db, GUEST_GROUPS_COLLECTION, groupId), payload);

    return {
      id: groupId,
      ...payload,
      updatedAt: new Date()
    };
  } catch (error) {
    console.error('Error updating conviventie guest group:', error);
    throw error;
  }
};

export const deleteGuestGroup = async (groupId) => {
  try {
    await deleteDoc(doc(db, GUEST_GROUPS_COLLECTION, groupId));
  } catch (error) {
    console.error('Error deleting conviventie guest group:', error);
    throw error;
  }
};
